@use "foundation/colors";
@use "foundation/responsive";

.payment-info-form {
  // Wider column so Payment Element can use a two-column card row (expiry + CVC) more often.
  // `min()` keeps mid-width flex layouts (e.g. combined checkout) from forcing past the parent column.
  max-width: min(540px, 100%);
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  
  strong {
    font-weight: 700;
  }

  @include responsive.tablet {
    margin: auto;
  }

  .price-container {
    display: flex;
    flex-direction: column;
    width: 100%;

    .price-list,
    .price-interval {
      display: flex;
      flex-direction: row;
      color: #22222206;
      font-size: 14px;
      gap: 12px;

      div {
        flex: 1;
        text-align: center;
      }
    }

    .price-interval {
      width: 100%;
      color: colors.$neutrals-grey;
    }

    // Segmented control (sliding thumb) — connected halves, modest radius (matches Stripe tabs).
    .price-toggle {
      position: relative;
      display: flex;
      flex-direction: row;
      width: 100%;
      box-sizing: border-box;
      padding: 4px;
      gap: 0;
      border-radius: 10px;
      background-color: #2222220d;
    }

    .price-toggle-thumb {
      position: absolute;
      top: 4px;
      bottom: 4px;
      left: 4px;
      width: calc(50% - 4px);
      border-radius: 8px;
      background-color: colors.$primary-white;
      box-shadow: 0 1px 4px rgb(0 0 0 / 10%);
      z-index: 0;
      pointer-events: none;
      transition: transform 0.22s ease;
    }

    .price-toggle--month .price-toggle-thumb {
      transform: translateX(100%);
    }

    .price-toggle-segment {
      position: relative;
      z-index: 1;
      flex: 1;
      text-align: center;
      // Tighter vertical rhythm inside the thumb; top still clears the SAVE pill (absolute in segment).
      padding: 32px 8px 10px;
      cursor: pointer;
      border-radius: 8px;
      border: 0.25em solid transparent;
      background-color: transparent;
      box-sizing: border-box;
      transition: border-color 0.2s ease, color 0.2s ease;

      .price-value,
      .price-period {
        color: rgb(34 34 34 / 45%);
      }

      &.selected-price {
        cursor: default;

        .price-value {
          color: colors.$primary-eerie-black;
        }

        .price-period {
          color: rgb(34 34 34 / 60%);
        }

        // No hover feedback on the active side (same look + default cursor as at rest).
        &:hover {
          .price-period {
            color: rgb(34 34 34 / 60%);
          }

          .price-value.full-price {
            color: colors.$neutrals-grey !important;
            text-decoration: line-through;
            font-size: 16px;
            line-height: 1em;
          }

          .price-value:not(.full-price) {
            color: colors.$primary-eerie-black;
          }
        }
      }

      &:hover {
        .price-value,
        .price-period {
          color: colors.$primary-eerie-black;
        }
      }
    }

    .price-list {
      width: 100%;

      .price-value {
        display: block;
        font-size: 32px;
        font-weight: 800;
        line-height: 1.1;

        &.full-price {
          color: colors.$neutrals-grey !important;
          text-decoration: line-through;
          font-size: 16px;
          line-height: 1em;
        }
      }

      .price-period {
        display: block;
        font-size: 14px;
        font-weight: 600;
        line-height: 1.3;
      }

      .price-discount {
        font-size: 12px;
        font-weight: 700;
        // Slightly less bottom than top so the copy looks vertically centered in the pill (line-height adds lower slack).
        padding: 5px 7px 3px;
        line-height: 1.3;
        color: white;
        // Same green as promo checkmarks / `promo_code_form` (`colors.$secondary-clover`).
        background-color: colors.$secondary-clover;
        border-radius: 6px;
        position: absolute;
        top: 4px;
        right: 4px;
        white-space: nowrap;

        &.hidden {
          display: none;
        }
      }

      // Annual segment unselected (monthly selected): pill matches muted annual price / track greys.
      .price-toggle .price-toggle-segment:not(.selected-price) .price-discount {
        background-color: rgb(34 34 34 / 9%);
        color: rgb(34 34 34 / 45%);
      }
    }

    .price-interval {
      div {
        font-weight: 600;
        opacity: 0;
      }

      .selected-interval {
        opacity: 1;
        transition: opacity 0.25s ease-out;

        span.full-price {
          text-decoration: line-through;
          font-size: 0.9em;
        }
      }
    }

    .price-annual-option {
      display: flex;
      flex-direction: column;
      background-color: colors.$neutrals-light-grey;
      border-radius: 0.85em;
      padding: 16px 20px;

      .title {
        font-weight: 700;
      }

      .price-value {
        font-weight: 900;
        font-size: 32px;
        margin: 4px 0;
      }

      .price-period {
        font-weight: 600;
        font-size: 14px;
        color: colors.$neutrals-dark-grey;
      }
    }
  }
}
